import { Autocomplete, Chip, TextField } from "@mui/material";
import { objType } from "data/globalData";
import React, { useState } from "react";

function MultipleSelectInput({ chips, options, onDelete, handleListAdd, disabled, sx, rows, placeHolder, size }) {
	if (typeof options === "function") options = options();
	console.log(options, chips, "chipschipschips");
	let { type, list, getOptionLabel } = options;

	if (type === objType) list = Object.keys(list)?.map((key) => list[key]);
	// if (typeof getOptionLabel === "function") list = list?.map((item) => getOptionLabel(item));
	else
		list = list?.map((item) => {
			if (typeof item === "object") return { ...item, label: item?.name };
			else return item;
		});
	let metadata = {};

	return (
		<Autocomplete
			clearIcon={false}
			options={list?.length ? list : []}
			getOptionLabel={(option) => {
				// console.log(option, "optionoption");
				if (typeof getOptionLabel === "function") return getOptionLabel(option);
				else if (typeof option === "object") return option?.name;
				else return option;
			}}
			sx={sx ? sx : {}}
			// freeSolo
			multiple
			value={chips}
			disableClearable
			disabled={disabled ? disabled : false}
			onChange={(e, newValue) => {
				// if (e.key === "Backspace") {
				// 	// setToAddoo
				// }
				console.log(newValue, "newValuenewValuenewValue");
				handleListAdd(newValue);
			}}
			// renderTags={(value, props) =>
			// 	value?.map((option, index) => (
			// 		<Chip
			// 			label={option}
			// 			{...props({ index })}
			// 			onDelete={() => {
			// 				onDelete(option);
			// 			}}
			// 		/>
			// 	))
			// }
			renderInput={(params) => (
				<TextField
					{...params}
					rows={rows ? rows : 1}
					multiline
					size={size ? size : "medium"}
					placeholder={`Enter ${placeHolder ? placeHolder : ""}`}
					// onKeyDown={(e) => {
					// 	if (e.key === "Enter") handleListAdd(e.target.value);
					// }}
				/>
			)}
		/>
	);
}

export default MultipleSelectInput;
